import pageOne from './pageOne.vue'
import pageTwo from './pageTwo.vue'
import pageThree from './pageThree.vue'
import pageFour from './pageFour.vue'
import pageFive from './pageFive.vue'
import confirmDialog from './confirmDialog.vue'
import ChooseCity from './ChooseCity.vue'
import pageSix from './pageSix.vue'

export { pageOne, pageTwo, pageThree, pageFour, pageFive, confirmDialog, ChooseCity, pageSix }
